'use client';

import { type Dispatch, useReducer } from 'react';

import { type VoiceoverGenerationSubmitState, type VoiceoverGenerationSubmitAction } from '../types';

export const VOICEOVER_GENERATION_SUBMIT_DEFAULTS: VoiceoverGenerationSubmitState = {
    status: 'idle',
};

export function voiceoverGenerationSubmitReducer(
    state: VoiceoverGenerationSubmitState,
    action: VoiceoverGenerationSubmitAction,
): VoiceoverGenerationSubmitState {
    switch (action.type) {
        case 'GENERATION_IN_PROGRESS':
            if (state.status === 'inProgress') return state;
            return { ...state, status: 'inProgress' };
        case 'GENERATION_SUCCESS':
            return { ...state, status: 'success' };
        case 'GENERATION_ERROR':
            return { ...state, status: 'error' };
        case 'RESET':
            return VOICEOVER_GENERATION_SUBMIT_DEFAULTS;
    }
}

export function useVoiceoverGenerationSubmit(): [
    VoiceoverGenerationSubmitState,
    Dispatch<VoiceoverGenerationSubmitAction>,
] {
    return useReducer(voiceoverGenerationSubmitReducer, VOICEOVER_GENERATION_SUBMIT_DEFAULTS);
}
